module.exports = __webpack_public_path__ + "static/media/download.27a539ff.png";